import { Box, styled } from '@mui/material'

interface WrapperProps {
  margin?: string | number
}

export const Wrapper = styled(Box)<WrapperProps>(({ margin }) => ({
  boxShadow: '0px 2px 10px 0px rgba(0, 0, 0, 0.10)',
  borderRadius: '6px',
  margin: margin || 2
}))
